import {
  COMMON_SUB_DOMAIN,
  PRODUCT_ORIGIN,
  MASTER_SUB_DOMAIN,
  PARTNER_SUB_DOMAIN,
  EVES_SUB_SYS_DOMAIN,
} from "@/config";
import { decodeJwtWithJsrs } from ".";

const getSubdomain = (): string => {
  if (window.location.host.includes("localhost")) {
    const subdomainParts = window.location.host.split("localhost");
    return subdomainParts[0] !== "" ? subdomainParts[0].split(".")[0] : "";
  } else if (PRODUCT_ORIGIN) {
    const subdomainParts = window.location.host.split(PRODUCT_ORIGIN);
    return subdomainParts[0] !== "" ? subdomainParts[0].split(".")[0] : "";
  }
  return "";
};

// XSM-1536 - SSO Feature
/**
 * Concatenates two text parameters with colon separator and returns the base64 encoded string
 * @param text1 First text parameter
 * @param text2 Second text parameter
 * @returns Base64 encoded string
 */
const concatAndEncodeBase64 = (text1: string, text2: string): string => {
  const concatenatedString = `${text1}:${text2}`;
  return window.btoa(concatenatedString);
};

const fetchLoggedUser = (): string => {
  const subDomain = getSubdomain();
  const defaultSubDomain = subDomain !== "" && subDomain !== COMMON_SUB_DOMAIN ? subDomain : MASTER_SUB_DOMAIN;
  const accessTokenKey = `${defaultSubDomain}_access_token`;
  // Check for subdomain-specific token first, then fallback to generic token
  const accessToken =
    localStorage.getItem(accessTokenKey) || localStorage.getItem("xsm_access_token");

  const tokenData = decodeJwtWithJsrs(accessToken);
  const loggedUserEmail = tokenData?.sub || "";
  return loggedUserEmail;
};

const applicationTitle = () => {
  const subDomain = getSubdomain();
  switch (subDomain) {
    case EVES_SUB_SYS_DOMAIN:
      return "EVES Ops";
    case PARTNER_SUB_DOMAIN:
      return "Access Manager";
    case MASTER_SUB_DOMAIN:
      return "App Registry";
    default:
      return "DynaChrg Ops";
  }
};

export { getSubdomain, concatAndEncodeBase64, fetchLoggedUser, applicationTitle };
